<template>
  <Modal v-model="modalState" class="PrivacyModalBox" :mask-closable="false" :mask="false" class-name="vertical-center-modal">
    <span slot="header"></span>
    <div class="modal-content">
      <ContentZH></ContentZH>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ContentZH from './zh-CN/PrivacyContent'

export default {
  name: 'PrivacyTermModal',
  components: { ContentZH },
  computed: {
    modalState: {
      get () {
        return this.isShowModal()
      },
      set (v) {
        this.setModalState(v)
      }
    }
  },
  methods: {
    ...mapState('account', {
      isShowModal: state => state.isShowPrivacy
    }),
    ...mapMutations({
      setModalState: 'account/setPrivacyModalState'
    })
  }
}
</script>
<style>
  .PrivacyModalBox .ivu-modal-wrap{
    z-index: 10501;
  }
  .PrivacyModalBox .vertical-center-modal,
  .PrivacyModalBox .ivu-modal{
    min-width: 650px;
  }
  .PrivacyModalBox .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: -20px;
  }
  .PrivacyModalBox .vertical-center-modal .ivu-modal{
    top: 12px;
  }
  .PrivacyModalBox .ivu-modal-content{
    border: 0.5px solid #D8D8D8;
    border-radius: 3px;
    padding: 0 5px;
  }
  .PrivacyModalBox .ivu-modal-header,
  .PrivacyModalBox .ivu-modal-footer{
    display: none;
  }
  .PrivacyModalBox .header{
    padding: 0px 16px 12px 2px;
    border-bottom: 0.5px solid #D8D8D8;
    font-size: 15px;
    color: #333;
    margin-bottom: 15px;
  }
  .PrivacyModalBox .footer{
    margin-top: 20px;
    margin-bottom: 8px;
  }
  .PrivacyModalBox .ivu-modal-close{
    top: 5px;
    right: 22px;
  }
  .PrivacyModalBox .ivu-modal-close:hover{
    text-decoration: none;
    box-shadow: none;
  }
  .PrivacyModalBox .ivu-btn{
    padding: 8px 20px;
    border-radius: 2px;
  }
  .PrivacyModalBox .ivu-btn-primary{
    background-color: #fff;
    color: #666;
    border: 0.5px solid #DBDBDB;
    border-radius: 3px;
    width: 120px;
    display: block;
    margin: 0 auto;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/account/PrivacyTerms.vue